export default {
      id: "i-print-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "img/sprite.svg#i-print",
      toString: function () {
        return this.url;
      }
    }